/* AUTH */
export const ACTION_ADD_TRAINING = 1;
export const ACTION_EDIT_TRAINING = 2;
export const ACTION_VIEW_TRAINING = 3;
